import { Component } from "@angular/core";
import { smoothlyMenu } from "../../app.helpers";
import { VernostServiceService } from "../../services/vernost-service.service";
import { Router } from "@angular/router";
import { Login } from "../../models/login";
// import { Navigation } from "../navigation/navigation.component";

@Component({
  selector: "topnavbar",
  templateUrl: "topnavbar.component.html"
})
export class Topnavbar {
  emailPattern =
    "^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$";
  passwordPattern = "^[a-zA-z0-9]{6,}$";
  screen_details: any = [];
  user1: any = {};
  parent_table = "mst_user";
  parent_table_Id = "USER_ID";
  USER_CODE = "USER_CODE";
  USER_FIRSTNAME = "USER_FIRSTNAME";
  USER_LASTNAME = "USER_LASTNAME";
  USER_EMAIL = "USER_EMAIL";
  USER_PASSWORD = "USER_PASSWORD";
  USER_ADDRESS = "USER_ADDRESS";
  USER_MOBILE = "USER_MOBILE";
  ROLE_ID = "ROLE_ID";
  returnUrl: string;
  errorUrl: string;
  functionality_data: any = [];

  role_name: string;

  dbFields = [this.USER_EMAIL, this.USER_PASSWORD];
  formData: any = [];
  uid: string;
  fname = "";
  lname = "";
  loginInfo: Login = {
    first_name: "Swapnil",
    last_name: "Mane",
    avatar: "vernost.png",
    title: "00210120121"
  };

  constructor(
    private router: Router,
    private vernostService: VernostServiceService
  ) { }
  toggleNavigation(): void {
    // jQuery("body").toggleClass("mini-navbar");
    smoothlyMenu();
  }

  ngOnInit() {
    // this.uid = localStorage.getItem('uid');
    this.dateTime("date_time");
    ////////console.log("this.router--->", this.router.url);
    this.uid = localStorage.getItem("uid");
    this.uid = sessionStorage.getItem("uid");
    this.fname = localStorage.getItem("fname");
    this.lname = localStorage.getItem("lname");
    // var array = {
    //   // parent_table: this.parent_table,
    //   // dbFields: this.dbFields,
    //   // parent_table_ID: this.parent_table_Id,
    //   uid: this.uid
    // };

    //console.log("uid=======" + this.uid);

    //console.log("array==============", array);

    // this.vernostService.loginSession(array).subscribe(response => {
    //   //console.log("response NAviation======" + JSON.stringify(response));

    //   this.functionality_data = response[0].result[0];

    //   //console.log(" this.functionality_data===========", response[0].result[0]);
    //   //console.log("role name" + response[0].result[0][0].ROLE_NAME);
    //   this.role_name = response[0].result[0][0].ROLE_NAME;
    // });
  }
  dateTime(id) {
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth();
    var months = new Array(
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "Jully",
      "August",
      "September",
      "October",
      "November",
      "December"
    );
    var d = date.getDate();
    var day = date.getDay();
    var days = new Array(
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    );
    var h = date.getHours();
    if (h < 10) {
      h = 0 + h;
    }
    var m = date.getMinutes();
    if (m < 10) {
      m = 0 + m;
    }
    var s = date.getSeconds();
    if (s < 10) {
      s = 0 + s;
    }
    var result =
      "" +
      days[day] +
      " " +
      months[month] +
      " " +
      d +
      " " +
      year +
      " " +
      h +
      ":" +
      m +
      ":" +
      s;
    if (document.getElementById(id) != undefined && document.getElementById(id) != null) {
      document.getElementById(id).innerHTML = result;
      setTimeout(() => this.dateTime("date_time"), 1000);
    }
    return true;
  }
  logout(): void {
    localStorage.removeItem("uid");
    localStorage.removeItem("ucode");
    localStorage.removeItem("fname");
    localStorage.removeItem("lname");
    localStorage.removeItem("roleID");
    sessionStorage.clear();
    sessionStorage.removeItem("uid");
    var url = "logout";
    this.vernostService.getDataApi(url).subscribe(response => {
      this.router.navigate(["/login"]);
    });
  }
  // logout() {
  //     localStorage.clear();
  //     // location.href='http://to_login_page';
  // }
}
